<template>
  <div>
    <a class="block block-link-pop text-right block-mode-loading-refresh" href="javascript:void(0)" :class="{'block-mode-loading': isProcessing}">
      <div class="block-content block-content-full clearfix">
          <div class="float-left mt-10 d-none d-sm-block">
              <i ><font-awesome-icon icon="running" class="fa-3x text-body-bg-dark" /></i>
          </div>
          <div class="font-size-h3 font-w600" data-toggle="countTo" data-speed="1000" data-to="1500">
            {{departures_count.departuredebtor + departures_count.departureContactface}}
          </div>
          <div class="font-size-sm font-w600 text-uppercase text-muted">Выездов</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      departures_count: [],
      isProcessing: false,
    };
  },
  mounted() {
    this.getCallsCount();
  },
  methods: {
    getCallsCount() {
      this.isProcessing = true;
      axios.get('/admin/stats/departures/count')
        .then((res) => {
          this.departures_count = res.data.departures_count;
          this.isProcessing = false;
        });
    },
  },
};
</script>
